import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Stack,
  Flex,
  Checkbox,
  Icon,
  Heading,
  Button,
  Select,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Divider,
  Grid,
} from "@chakra-ui/react";
import { InfoOutlineIcon, DownloadIcon } from "@chakra-ui/icons";
import { FaSync, FaPrint } from "react-icons/fa";
import axios from "axios";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Individual_Events = () => {
  const [currentEvents, setCurrentEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [formData, setFormData] = useState({});

  const userId = sessionStorage.getItem("user_id");
  const userType = sessionStorage.getItem("user_type");

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(currentEvents.length / rowsPerPage);
  const indexOfLastEvent = currentPage * rowsPerPage;
  const indexOfFirstEvent = indexOfLastEvent - rowsPerPage;

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleEventClick = async (event) => {
    console.log("Event clicked:", event);

    // if (!event?.id) {
    //   console.error("Invalid event object:", event);
    //   return;
    // }
    try {
      const response = await axios.get(
        `${BASE_URL}/admin/events/event/view_event.php?event_id=${event}`
      );
      console.log("data", response);

      if (response.data.success) {
        const fetchedEvent = response.data.data.event;
        setFormData({
          id: fetchedEvent.id,
          title: fetchedEvent.event_title,
          message: fetchedEvent.message,
          start_date: fetchedEvent.start_date,
          end_date: fetchedEvent.end_date,
          start_time: fetchedEvent.start_time,
          end_time: fetchedEvent.end_time,
          attachment: fetchedEvent.attachment,
          user_types: fetchedEvent.user_types || [],
        });
        setIsDetailModalOpen(true);
      } else {
        // Handle error fetching event details
        console.error("Error fetching event details:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching event details:", error);
      // Handle error
    }
  };

  useEffect(() => {
    const fetchEvents = async () => {
      setLoading(true);
      setError(null);

      try {
        let url = "";
        let method = "POST"; // Default method is POST
        let payload = null; // Default payload is null

        if (userType === "3") {
          // Student
          url = `${BASE_URL}/student/list_events.php`;
          payload = { pass: userId };
        } else if (userType === "4") {
          // Guardian
          url = `${BASE_URL}/guardian/list_events.php`;
          payload = { pass: userId };
        } else if (userType === "2") {
          // Staff (GET request)
          url = `${BASE_URL}/staff/profile/list_teachers_event.php?user_id=${userId}`;
          method = "GET";
        } else {
          throw new Error("Invalid user type");
        }

        let response;
        if (method === "POST") {
          response = await axios.post(url, payload);
        } else {
          response = await axios.get(url);
        }

        if (response.data.success) {
          setCurrentEvents(response.data.data || []); // Safely handle response data
        } else {
          setError(response.data.message || "Failed to fetch events.");
        }
      } catch (err) {
        setError("An error occurred while fetching events.");
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, [userId, userType]);

  if (loading) return <Text>Loading...</Text>;
  if (error) return <Text color="red.500">{error}</Text>;

  return (
    <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
      <div className="teacher-list-container">
        <div className="header">
          <h1 style={{ fontSize: "20px", margin: 0 }}>Event Board</h1>
          <div className="action-buttons">
            {/* <Button onClick={() => window.location.reload()} boxShadow="md" backgroundColor="white" fontSize="11px">
              <FaSync color="#515B73" />
            </Button> */}
            <Button
              className="export-button"
              display={{ base: "none", md: "flex" }}
              backgroundColor="white"
              fontSize="11px"
              boxShadow="md"
              // onClick={handlePrint} // Attach the print handler here
            >
              <FaPrint color="#515B73" />
              Print PDF
            </Button>
          </div>
        </div>
        <div className="breadcrumb">
          <span>Admin</span> / <span>Announcement</span> / <span>Events</span>
        </div>
      </div>

      <Box className="event-list" style={{ minHeight: "100px" }} p={6} pb={0}>
        <Flex align="center" className="sb1" p={3}>
          <Text mr={1}>Rows Per Page</Text>
          <Select
            width="100px"
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
            borderColor="#E9EDF4"
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </Select>
          <Text ml={2}>Entries</Text>
        </Flex>

        {currentEvents.length === 0 ? (
          <Text>No events available</Text>
        ) : (
          <Grid
            templateColumns={{
              base: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(4, 1fr)",
            }} // 1-column on mobile, 2-column on small screens, 4-column on larger screens
            gap={4}
          >
            {currentEvents
              .slice(indexOfFirstEvent, indexOfLastEvent)
              .map((event) => (
                <Box
                  key={event.id}
                  mt={2}
                  p={2} // Reduced padding for each event card
                  shadow="md"
                  borderWidth="1px"
                  borderRadius="lg"
                  backgroundColor="white"
                  fontSize="sm" // Optionally set a smaller default font size
                >
                  <Flex justify="space-between" align="center" mb={1}>
                    <Flex align="center">
                      <Checkbox mr={2} size="sm" />{" "}
                      {/* Smaller checkbox size */}
                      <Icon as={InfoOutlineIcon} boxSize={3} mr={2} />{" "}
                      {/* Smaller icon size */}
                      <Box pl={2}>
                        <Heading
                          fontSize="xs" // Reduced event title font size
                          style={{ cursor: "pointer" }}
                          onClick={() => handleEventClick(event.id)}
                        >
                          {event.event_title}
                        </Heading>
                        {/* Event date information */}
                        <Text fontSize="xs" color="gray.500" mt={1}>
                          {" "}
                          {/* Reduced font size */}
                          Created On:{" "}
                          {event.event_date || event.created_at || "N/A"}
                        </Text>
                      </Box>
                    </Flex>
                  </Flex>
                </Box>
              ))}
          </Grid>
        )}
        <Flex justify="end" align="center" className="sb2" p={3}>
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            isDisabled={currentPage === 1}
          >
            Prev
          </Button>
          <Stack direction="row" spacing={2} mx={2}>
            {Array.from({ length: totalPages }, (_, i) => (
              <Button
                key={i}
                onClick={() => handlePageChange(i + 1)}
                colorScheme={currentPage === i + 1 ? "teal" : "gray"}
              >
                {i + 1}
              </Button>
            ))}
          </Stack>
          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            isDisabled={currentPage === totalPages}
          >
            Next
          </Button>
        </Flex>
      </Box>

      {/* Modal for event details */}
      <Modal
        isOpen={isDetailModalOpen}
        onClose={() => setIsDetailModalOpen(false)}
      >
        <ModalOverlay />
        <ModalContent
          width="400px"
          maxWidth="400px"
          borderRadius="md"
          bg="teal.100" // Background color for sticky note effect
          boxShadow="lg"
        >
          <ModalHeader fontWeight="bold" color="black">
            Event Details
          </ModalHeader>
          <Divider />
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            height="320px"
            bg="white"
            borderRadius="md"
            p={4}
          >
            {formData && (
              <>
                <Text fontWeight="bold" fontSize="lg" color="black">
                  {formData.title}
                </Text>
                <Text mt={1} color="gray.600">
                  {formData.message}
                </Text>
                <Box mt={4}>
                  <Flex justify="space-between" alignItems="flex-start" mb={2}>
                    {formData.start_date && (
                      <Box>
                        <Text fontSize="sm" fontWeight="bold" color="black">
                          Start Date
                        </Text>
                        <Text fontSize="sm" color="gray.500">
                          {new Date(formData.start_date).toLocaleDateString()}
                        </Text>
                        {formData.start_time && (
                          <>
                            <Text
                              fontSize="sm"
                              fontWeight="bold"
                              color="black"
                              mt={2}
                            >
                              Start Time
                            </Text>
                            <Text fontSize="sm" color="gray.500">
                              {formData.start_time}
                            </Text>
                          </>
                        )}
                      </Box>
                    )}
                    {formData.end_date && (
                      <Box textAlign="right">
                        <Text fontSize="sm" fontWeight="bold" color="black">
                          End Date
                        </Text>
                        <Text fontSize="sm" color="gray.500">
                          {new Date(formData.end_date).toLocaleDateString()}
                        </Text>
                        {formData.end_time && (
                          <>
                            <Text
                              fontSize="sm"
                              fontWeight="bold"
                              color="black"
                              mt={2}
                            >
                              End Time
                            </Text>
                            <Text fontSize="sm" color="gray.500">
                              {formData.end_time}
                            </Text>
                          </>
                        )}
                      </Box>
                    )}
                  </Flex>
                </Box>
                {formData.attachment && (
                  <Box mt={4}>
                    <Text fontWeight="bold" fontSize="sm">
                      Attachment
                    </Text>
                    <Button
                      as="a"
                      href={formData.attachment}
                      download
                      colorScheme="teal"
                      mt={2}
                      size="sm"
                      leftIcon={<Icon as={DownloadIcon} />}
                    >
                      Download Attachment
                    </Button>
                  </Box>
                )}
              </>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default Individual_Events;
